import React, { useEffect, useState } from "react";
import { Toast } from "antd-mobile";
import { SpeedBtn, ScoreXBtn } from "../../../components/button";
import rocket from '@/assets/img/landfi/rocket.png';
import classNames from "classnames";
import './index.scss';

const LevelInfo = (props) => {
  const {mode, onSpeed, expGemInfo} = props;
  const [progressLength, setProgressLength] = useState(0)
  const {  expLevel = 0, exp = 0, expMax = 0, gemstonesCount = 0, isUseCard, times ,addNum} = expGemInfo
  
  useEffect(() => {
    const progress = 40;// Number((Number(exp)/Number(expMax)).toFixed(2))*100
    setProgressLength(progress > 100 ? 100: progress)
  }, [expGemInfo])

  return (
    <div className={`land-game-levelinfo`}>
      <div className="land-game-levelbar">
        <div className="land-game-levelbarinner" style={{ width: `${progressLength}%`, transition: '1.5s' }}>
          <div className={classNames("exp_num_box", {exp_num: progressLength < 34 && progressLength > 0})}>
            {exp === expMax ? <span>{exp}</span>: <span>{exp}/{expMax}</span>}
          </div>
          {isUseCard === 1 ? <div className={classNames("land-game-levelbarinner-rocket", {exp_100: progressLength === 100})}>
            {progressLength === 0 ? <div className="exp_0"></div>: <img src={rocket} alt="" />}
            <span>{`已叠加${addNum || '0'}张加速卡，${times}倍加速中～`}</span>
          </div>: null}
        </div>
        <div className="land-game-levelbg">{Number(expLevel) < 10 ? `0${expLevel}`: expLevel}</div>
      </div>
      <SpeedBtn className={classNames({mode2: +mode !== 1})} onClick={onSpeed}></SpeedBtn>
      <ScoreXBtn gemCount={gemstonesCount}></ScoreXBtn>
    </div>
  );
};

export default LevelInfo;
